import { createReducer, on } from '@ngrx/store';
import { SnackbarActions } from './snackbar.actions';

export interface SnackbarState {
  show: boolean;
}

const initialState: SnackbarState = {
  show: false
};

export const reducer = createReducer(
  initialState,
  on(SnackbarActions.snackbar_open, (state: SnackbarState) => ({
    ...state,
    show: true
  })),
  on(SnackbarActions.snackbar_close, (state: SnackbarState) => ({
    ...state,
    show: false
  }))
);
